import React, {
  useEffect, useContext, useState, useCallback,
} from 'react';
import { Link } from 'react-router-dom';
import ServiceBanners from '../components/ServiceBanners';
import UserServicesDashboard from '../components/UserServicesDashboard';
import { AuthContext } from '../context/AuthContext';
import { fetchUserDetails } from '../services/apiService';
import menuItemsByService from '../categories/serviceMenus';
import { useSidebar } from '../context/SidebarContext';

function Dashboard() {
  const {
    triggerMenuUpdate, justLoggedIn, setJustLoggedIn, authTokens, impersonatedUserId,

  } = useContext(AuthContext);
  const { isSidebarOpen } = useSidebar();
  const [userServices, setUserServices] = useState([]);

  const loadUserServices = useCallback(async () => {
    if (authTokens && (impersonatedUserId || authTokens.userRole !== 'admin')) {
      try {
        const userIdToFetch = impersonatedUserId || authTokens.userId;
        const userDetails = await fetchUserDetails(userIdToFetch, authTokens);
        const serviceOrder = {
          'Anexo 30 y 31 2022': 1,
          'Anexo 30 y 31 2023': 2,
          'Anexo 30 y 31 2024': 3,
          'Anexo 30 y 31 2025': 4,
          'Anexo 21 y 22 rmf 2026': 5,
          'Transporte Anexo 21 y 22 rmf 2026': 6,
          'Distribución Anexo 21 y 22 rmf 2026': 7,
          'Comercializadora Anexo 21 y 22 rmf 2026': 8,
          'Dictamen de Diseño': 9,
          'NOM-016-CRE-2016': 10,
          'Anexo 30 y 31 para transporte o distribución': 11,
        };
        const sortedServices = userDetails.services.sort(
          (a, b) => (serviceOrder[a.name] || 0) - (serviceOrder[b.name] || 0),
        );
        setUserServices(sortedServices);
      } catch (error) {
        console.error('Error al cargar los servicios del usuario:', error);
      }
    }
  }, [authTokens, impersonatedUserId]);

  useEffect(() => {
    loadUserServices();
  }, [loadUserServices]);

  useEffect(() => {
    if (justLoggedIn) {
      console.log('Just logged in, triggering menu update...');
      setTimeout(() => {
        console.log('Triggering menu update...');
        triggerMenuUpdate();
        setJustLoggedIn(false);
      }, 3000);
    }
  }, [justLoggedIn, triggerMenuUpdate, setJustLoggedIn]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`fixed md:fixed top-16 left-0 h-[calc(100vh-4rem)] overflow-y-auto transform
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          transition duration-200 ease-in-out
          w-64 bg-white shadow-lg z-40`}
      >
        <div className="p-8 border-b">
          <img src="/images/logo2.png" alt="Logo Petrotec" className="h-32 w-auto mx-auto" />
        </div>
        <nav className="mt-6">
          <Link
            to="/dashboard"
            className={`
              block px-4 py-3 hover:bg-blue-50 transition-colors duration-200
              text-gray-700 hover:text-blue-600 border-b border-gray-100
            `}
          >
            Inicio
          </Link>
          <div className="px-4 py-2">
            <h2 className="text-xs uppercase font-semibold text-gray-600 tracking-wide">
              Servicios Disponibles
            </h2>
          </div>
          {userServices.map((service) => {
            const firstMenuItem = menuItemsByService[service.name]?.[0];
            return (
              <Link
                key={service.id}
                to={firstMenuItem?.path || '#'}
                className="block px-4 py-3 hover:bg-blue-50 transition-colors duration-200 text-gray-700 hover:text-blue-600"
              >
                {service.name}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div className={`flex-1 transition-all duration-200 ${isSidebarOpen ? 'md:ml-64' : ''}`}>

        <div className="p-8 pb-16">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Bienvenido a Metroenergy</h1>
            <p className="mt-2 text-gray-600">Gestiona tus servicios y documentación desde un solo lugar.</p>
          </div>

          {/* Quick Stats or User Services Dashboard */}
          <div className="grid grid-cols-1 gap-6 mb-8">
            <UserServicesDashboard />
          </div>

          {/* Instructions Panel */}
          <div className="bg-white shadow-lg rounded-lg p-8 mb-8">
            <h2 className="text-xl font-semibold mb-4">Cómo empezar:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>
                Selecciona un servicio del
                <strong> menú lateral</strong>
                {' '}
                para comenzar a gestionar tu documentación.
              </li>
              <li>
                Asegúrate de subir la
                <strong> documentación y fotografías</strong>
                {' '}
                completas para cada servicio.
              </li>
              <li>
                Nuestros asesores revisarán tu
                <strong> documentación</strong>
                {' '}
                y te proporcionarán retroalimentación.
              </li>
              <li>La sección de ayuda está disponible si necesitas asistencia adicional.</li>
            </ul>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
              <p className="text-blue-800">
                ¿Necesitas ayuda? Contáctanos:
              </p>
              <p className="mt-2">
                Teléfono:
                <strong className="text-blue-700"> (221) 15 96 130 </strong>
              </p>
              <p>
                WhatsApp:
                <strong className="text-blue-700"> (221) 15 96 227 </strong>
              </p>
            </div>
          </div>

          {/* Service Banners at the bottom */}
          <ServiceBanners />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
